import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListEmployeeFeedbackRequestStart,
  getListEmployeeFeedbackRequestSuccess,
  getListEmployeeFeedbackRequestFailed,
} from "../redux/getListEmployeeFeedbackRequest";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { formFilterEmployeeLeaveSelector } from "../redux/selector";
import { getEmployeeFeedbackRequestApi } from "core/http/service/employeeRequest";
import { typeScrollEmployeeRequest } from "./exportEmployeeRequest";

function* getListEmployeeFeedbackRequestWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector(typeScrollEmployeeRequest.explain)
  );
  const { from, to, ...rest } = yield select(formFilterEmployeeLeaveSelector);

  const params = {
    offset,
    limit,
    ...rest,
    fromMonth: from?.month() + 1,
    fromYear: from?.year(),
    toYear: to?.year(),
    toMonth: to?.month() + 1,
  };
  try {
    const res = yield call(getEmployeeFeedbackRequestApi, params);
    yield put({
      type: getListEmployeeFeedbackRequestSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListEmployeeFeedbackRequestFailed.type,
    });
  }
}

function* watchGetListEmployeeFeedbackRequest() {
  yield takeLatest(
    getListEmployeeFeedbackRequestStart.type,
    getListEmployeeFeedbackRequestWork
  );
}

export default function* getListEmployeeFeedbackRequestSaga() {
  yield all([watchGetListEmployeeFeedbackRequest()]);
}
